import { Link as RouterLink } from "react-router";
import { ICellRendererParams, IHeaderParams } from "ag-grid-community";
import { Box, Stack, Tooltip } from "@mui/material";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";
import { JSX } from "react";
import { Link, Typography } from "@platform/design-system";

import { ROUTE_NAMES } from "../constants";
import { sortProductsByCoverage } from "../pages/RFP/utils";
import { Product } from "../types/clientTab";
import { RfpListItem } from "../hooks/useRfpsList";

export const RenderCellLink: React.FC<
  ICellRendererParams<RfpListItem, string>
> = (params) => {
  const name = params.value;
  const products = sortProductsByCoverage(params.data.products) as Product[];
  const productCount = products?.length || 0;
  const id = params.data.id;

  return (
    <Link
      component={RouterLink}
      to={`/${ROUTE_NAMES.CLIENTS}/${id}`}
      underline="none"
    >
      <Stack direction="column" spacing={0} p={1}>
        <Typography color="inherit">
          <strong>{name}</strong>
        </Typography>

        <Tooltip title={[...new Set(products)].toString()}>
          <Box>
            <Typography variant="body-medium">
              Client with{" "}
              <Link component="span" underline="none">
                <strong>{productCount} products</strong>
              </Link>
            </Typography>
          </Box>
        </Tooltip>
      </Stack>
    </Link>
  );
};

export const renderCell = (value: string | number): JSX.Element => (
  <Typography variant="body-medium">{value}</Typography>
);

export const InfoHeaderIcon = (params: IHeaderParams): JSX.Element => (
  <Stack
    spacing={0.5}
    direction="row"
    alignItems="center"
    sx={{
      "& .sort-icon": {
        opacity: 0,
        transition: "opacity 0.15s ease-in-out",
      },
      "&:hover .sort-icon": {
        opacity: 1,
      },
    }}
  >
    <div>{params.displayName}</div>

    <InfoOutlineIcon fontSize="small" />
  </Stack>
);
